export default "__VITE_ASSET__BpUcaGkK__"